module.exports = __webpack_public_path__ + "static/media/username.93154ced.png";